import { GraphMutationBuilderPayload, createMutation } from '@camelot/server';

import {
  CalendarSyncConfigurationCreationPayloadInput,
  CalendarSyncConfigurationModifierPayloadInput,
} from './dto/calendar-sync-config';
import {
  CalendarTimeEntryCreationPayloadInput,
  CalendarTimeEntryModifierPayloadInput,
} from './dto/calendar-time-entry';
import { ColorSetCreationPayloadInput, ColorSetModifierPayloadInput } from './dto/color-set';
import { NoteTypeCreationPayloadInput, NoteTypeModifierPayloadInput } from './dto/note-type';
import { CalendarNoteCreationPayloadInput } from './dto/post/calendar-note-creation-payload-input';
import { CalendarNoteModifierPayloadInput } from './dto/post/calendar-note-modifier-payload-input';
import { UnavailabilityCreationPayloadInput } from './dto/post/unavailability-creation-payload-input';
import { UnavailabilityModifierPayloadInput } from './dto/post/unavailability-modifier-payload-input';
import { VisitCreationPayloadInput } from './dto/post/visit-creation-payload-input';
import { VisitModifierPayloadInput } from './dto/post/visit-modifier-payload-input';
import {
  UserCalendarSubscriptionCreationPayload,
  UserCalendarSubscriptionModifierPayload,
} from './dto/user-calendar-subscription';

export function CREATE_VISIT(visitCreationPayload: VisitCreationPayloadInput): GraphMutationBuilderPayload {
  return createMutation('createVisit', {
    argument: 'visitCreationPayload',
    value: visitCreationPayload,
  });
}

export function UPDATE_VISIT(visitModifierPayload: Partial<VisitModifierPayloadInput>): GraphMutationBuilderPayload {
  return createMutation('updateVisit', {
    argument: 'visitModifierPayload',
    value: visitModifierPayload,
  });
}

export function CREATE_UNAVAILABILITY(
  unavailabilityCreationPayload: UnavailabilityCreationPayloadInput
): GraphMutationBuilderPayload {
  return createMutation('createNewUnavailability', {
    argument: 'unavailabilityCreationPayload',
    value: unavailabilityCreationPayload,
  });
}

export function UPDATE_UNAVAILABILITY(
  unavailabilityModifierPayload: Partial<UnavailabilityModifierPayloadInput>
): GraphMutationBuilderPayload {
  return createMutation('updateUnavailability', {
    argument: 'unavailabilityModifierPayload',
    value: unavailabilityModifierPayload,
  });
}

export function CREATE_CALENDAR_NOTE(
  calendarNoteCreationPayload: CalendarNoteCreationPayloadInput
): GraphMutationBuilderPayload {
  return createMutation('createNewCalendarNote', {
    argument: 'calendarNoteCreationPayload',
    value: calendarNoteCreationPayload,
  });
}

export function UPDATE_CALENDAR_NOTE(
  calendarNoteModifierPayload: Partial<CalendarNoteModifierPayloadInput>
): GraphMutationBuilderPayload {
  return createMutation('updateCalendarNote', {
    argument: 'calendarNoteModifierPayload',
    value: calendarNoteModifierPayload,
  });
}

export function CREATE_NOTE_TYPE(noteType: NoteTypeCreationPayloadInput): GraphMutationBuilderPayload {
  return createMutation('createNewNoteType', {
    argument: 'noteTypeCreationPayload',
    value: noteType,
  });
}

export function UPDATE_NOTE_TYPE(noteType: Partial<NoteTypeModifierPayloadInput>): GraphMutationBuilderPayload {
  return createMutation('updateNoteType', {
    argument: 'noteTypeModifierPayload',
    value: noteType,
  });
}

export function CREATE_TIME_ENTRY(timeEntry: CalendarTimeEntryCreationPayloadInput): GraphMutationBuilderPayload {
  return createMutation('createNewTimeEntry', {
    argument: 'timeEntryCreationPayload',
    value: timeEntry,
  });
}

export function UPDATE_TIME_ENTRY(
  timeEntry: Partial<CalendarTimeEntryModifierPayloadInput>
): GraphMutationBuilderPayload {
  return createMutation('updateTimeEntry', {
    argument: 'timeEntryModifierPayload',
    value: timeEntry,
  });
}

export function CREATE_COLOR_SET(colorSet: ColorSetCreationPayloadInput): GraphMutationBuilderPayload {
  return createMutation('createNewColorSet', {
    argument: 'colorSetCreationPayload',
    value: colorSet,
  });
}

export function UPDATE_COLOR_SET(colorSet: Partial<ColorSetModifierPayloadInput>): GraphMutationBuilderPayload {
  return createMutation('updateColorSet', {
    argument: 'colorSetModifierPayload',
    value: colorSet,
  });
}

export function CREATE_CALENDAR_SYNC_CONFIG(
  payload: CalendarSyncConfigurationCreationPayloadInput
): GraphMutationBuilderPayload {
  return createMutation('createCalendarSyncConfiguration', {
    argument: 'calendarSyncConfigurationCreationPayload',
    value: payload,
  });
}

export function UPDATE_CALENDAR_SYNC_CONFIG(
  payload: Partial<CalendarSyncConfigurationModifierPayloadInput>
): GraphMutationBuilderPayload {
  return createMutation('updateCalendarSyncConfiguration', {
    argument: 'calendarSyncConfigurationModifierPayload',
    value: payload,
  });
}

export function CREATE_USER_CALENDAR_SUBSCRIPTION(
  payload: UserCalendarSubscriptionCreationPayload
): GraphMutationBuilderPayload {
  return createMutation('createUserCalendarSubscription', {
    argument: 'userCalendarSubscriptionCreationPayload',
    value: payload,
  });
}

export function UPDATE_USER_CALENDAR_SUBSCRIPTION(
  payload: Partial<UserCalendarSubscriptionModifierPayload>
): GraphMutationBuilderPayload {
  return createMutation('updateUserCalendarSubscription', {
    argument: 'userCalendarSubscriptionModifierPayload',
    value: payload,
  });
}
